import React, {Component} from 'react';
import PossibleValues from './possible-values';
import FieldNoteForDevelopers from '../note-for-developers';
import FieldLabel from '../field-label';
import FieldHelpText from '../field-help-text';
import FieldMandatory from '../field-mandatory';
import FieldWidth from '../field-width';
import ConditionId from '../condition-id';

const DataSource = {
  CUSTOM_LIST: 'CUSTOM_LIST',
  COUNTRIES: 'COUNTRIES',
  US_STATES: 'US_STATES',
};

export default class DropdownField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateModel(key, value) {
    this.setState(
      prevState => {
        const model = prevState.model;
        model[key] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <>
      <FieldLabel value={this.state.model.label} onChange={v => this.updateModel('label', v)} />
      <div className="mb-3">
        <label htmlFor="placeholder" className="form-label">Placeholder</label>
        <input id="placeholder" name="placeholder"
               type="text"
               className="form-control"
               value={this.state.model.placeholder || ''}
               onChange={e => {
                 const value = e.target.value;
                 this.updateModel('placeholder', value);
                 if (value) {
                   this.updateModel('defaultValue', null);
                 }
               }} />
        <div className="form-text">Short hint, will appear in the dropdown before any selection is made.</div>
      </div>
      <FieldHelpText value={this.state.model.helpText} onChange={v => this.updateModel('helpText', v)} />
      <div className="card my-4">
        <div className="card-header">
          List of values
        </div>
        <div className="card-body">
          <div className="form-check">
            <input type="radio"
                   name={'dataSource' + this.props.id}
                   id={this.props.id + 'CustomList'}
                   className="form-check-input"
                   value={DataSource.CUSTOM_LIST}
                   checked={!this.state.model.dataSource || this.state.model.dataSource === DataSource.CUSTOM_LIST}
                   onChange={e => this.updateModel('dataSource', e.target.value)}/>
            <label className="form-check-label" htmlFor={this.props.id + 'CustomList'}>
              Custom list
            </label>
          </div>
          {(!this.state.model.dataSource || this.state.model.dataSource === DataSource.CUSTOM_LIST) &&
          <PossibleValues value={this.state.model.possibleValues}
                          onChange={value => this.updateModel('possibleValues', value)}/>
          }
          <div className="form-check">
            <input type="radio"
                   name={'dataSource' + this.props.id}
                   id={this.props.id + 'Countries'}
                   className="form-check-input"
                   value={DataSource.COUNTRIES}
                   checked={this.state.model.dataSource === DataSource.COUNTRIES}
                   onChange={e => this.updateModel('dataSource', e.target.value)}/>
            <label className="form-check-label" htmlFor={this.props.id + 'Countries'}>
              List of all countries
            </label>
          </div>
          <div className="form-check">
          <input type="radio"
                 name={'dataSource' + this.props.id}
                 id={this.props.id + 'UsStates'}
                 className="form-check-input"
                 value={DataSource.US_STATES}
                 checked={this.state.model.dataSource === DataSource.US_STATES}
                 onChange={e => this.updateModel('dataSource', e.target.value)}/>
          <label className="form-check-label" htmlFor={this.props.id + 'UsStates'}>
            List of all US states
          </label>
        </div>
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="defaultValue" className="form-label">Default value</label>
        <input id="defaultValue" name="defaultValue"
               type="text"
               className="form-control"
               value={this.state.model.defaultValue || ''}
               onChange={e => this.updateModel('defaultValue', e.target.value)}
               disabled={!!this.state.model.placeholder} />
        {this.state.model.placeholder &&
        <div className="form-text">Only relevant when there is no placeholder</div>
        }
      </div>
      <FieldMandatory id={this.props.id}
                      value={this.state.model.mandatory}
                      onChange={v => this.updateModel('mandatory', v)}
                      conditionallyDisplayed={!!this.state.model.conditionId}/>
      <FieldWidth value={this.state.model.widthInPercent} onChange={v => this.updateModel('widthInPercent', v)} />
      <ConditionId id={this.props.id}
                   conditions={this.state.conditions}
                   value={this.state.model.conditionId}
                   onChange={v => this.updateModel('conditionId', v)}/>
      <FieldNoteForDevelopers label={this.state.model.label}
                              placeholder={this.state.model.placeholder} />
    </>
  }

}
